module.exports = __webpack_public_path__ + "static/media/bha.9dadd67e.png";